import * as actionTypes from '../actions/actionTypes'

const initialState = {
    aboutRef: undefined,
    achievementsRef: undefined,
    contactRef: undefined,
    homeRef: undefined,
    experiencesRef: undefined,
    strengthsRef: undefined,
}

const refReducer = (state = initialState, action) => {
    const { type, payload } = action

    switch (type) {
        case actionTypes.SET_ABOUT_REF:
            if (payload.aboutRef)
                return {
                    ...state,
                    aboutRef: payload.aboutRef,
                }
            return { ...state }

        case actionTypes.SET_ACHIEVEMENTS_REF:
            if (payload.achievementsRef)
                return {
                    ...state,
                    achievementsRef: payload.achievementsRef,
                }
            return { ...state }

        case actionTypes.SET_BLOGS_REF:
            if (payload.blogsRef)
                return {
                    ...state,
                    blogsRef: payload.blogsRef,
                }
            return { ...state }

        case actionTypes.SET_CONATCT_REF:
            if (payload.contactRef)
                return {
                    ...state,
                    contactRef: payload.contactRef,
                }
            return { ...state }

        case actionTypes.SET_EXPERIENCES_REF:
            if (payload.experiencesRef)
                return {
                    ...state,
                    experiencesRef: payload.experiencesRef,
                }
            return { ...state }

        case actionTypes.SET_HOME_REF:
            if (payload.homeRef)
                return {
                    ...state,
                    homeRef: payload.homeRef,
                }
            return { ...state }

        case actionTypes.SET_STRENGTHS_REF:
            if (payload.strengthsRef)
                return {
                    ...state,
                    strengthsRef: payload.strengthsRef,
                }
            return { ...state }

        default:
            return { ...state }
    }
}

export default refReducer